import axios from 'axios'

const apiClient = axios.create({
  baseURL: '/api',
  withCredentials: true,
  headers: {
    'Content-Type': 'application/json',
  },
})

// Token will be set from URL parameter
let accessToken: string | null = null

export const setAccessToken = (token: string) => {
  accessToken = token
  apiClient.defaults.headers.common['X-Access-Token'] = token
}

export const getAccessToken = () => accessToken

// Response interceptor for error handling
apiClient.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401 && accessToken) {
      // Only redirect for token-based access (public /view/:token links)
      // Cookie-based auth is handled by ProtectedRoute
      window.location.href = '/error?reason=unauthorized'
    }
    return Promise.reject(error)
  }
)

export default apiClient
